module.exports = __webpack_public_path__ + "img/preview-1.ba52b925.webp";